import React, { useState, useEffect } from 'react'
// import { Autocomplete, useLoadScript } from "@react-google-maps/api";
// const placesLibrary = ["places"];
import Autocomplete from '@mui/material/Autocomplete'
import TextField from '@mui/material/TextField'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { getCityList } from '../../../../redux/slices/hotel'
import { useSelector, useDispatch } from 'react-redux'
import AttractionsIcon from '@mui/icons-material/Attractions'
import Icon from '@mui/material/Icon'
import PublicIcon from '@mui/icons-material/Public'
import FlightLandIcon from '@mui/icons-material/FlightLand'
import { InputAdornment } from '@mui/material'
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  ListSubheader
} from '@mui/material'
import { airportNameList1 } from '../../../../redux/slices/flight'
import Image from 'next/image'

import { Skeleton } from "@mui/material";

const HotelDestination = ({
  setCityValue,
  cityValue,
  setSearchProduct,
  searchProduct,
  selectedValue,
  setSelectedValue,
  label,
  placeholder,
  setLoading,
  loading,
  autocompleteNext,
  focusNext,
  error,
  helperText
}) => {
  const dispatch = useDispatch()
  const { cityListRes } = useSelector(state => state.hotel)
  const [cityList, setCityList] = useState([])
  const { flightListName1Res } = useSelector(state => state.flight)

  useEffect(() => {
    dispatch(getCityList({ search: '' }))
  }, [])

  useEffect(() => {
    dispatch(airportNameList1({ search: '' }))
  }, [])

  useEffect(() => {
    if (flightListName1Res) {
      setCityList(flightListName1Res)
    }
  }, [flightListName1Res])

  useEffect(() => {
    if (cityListRes) {
      setCityList(cityListRes.cityList)
    }
  }, [cityListRes])

  const flattenedOptions = cityValue.reduce((acc, curr) => {
    const values = Array.isArray(curr?.values) ? curr.values : []
    return [
      ...acc,
      ...values.map(value => ({
        group: curr.label,
        img: curr.img,
        formatedLabel: `${value.municipality} (${value.iata_code})`,
        ...value
      }))
    ]
  }, [])

  const handlePaste = event => {
    event.preventDefault() // Prevent default paste behavior
  }

  return (
    <Box className={`searchMenu-loc lg:px-0 js-form-dd`}
      sx={{
        '& label.Mui-focused': {
          color: 'black'
        },

        '& .MuiListSubheader-root': {
          // height: "16px",
          backgroundColor: 'red'
        },
        '& .MuiInputBase-input': {
          // height: "16px",
        },
        '& .MuiAutocomplete-clearIndicator': {
          display: 'none' // Hides the clear (close) button
        },

        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
          border: '1px solid rgba(0, 0, 0, 0.5)'
        },
        '& .MuiInput-underline:after': {
          border: '1px solid rgba(0, 0, 0, 0.5)'
        },
        '& .MuiAutocomplete-listbox': {
          overflow: 'hidden'
        },
        '& .MuiOutlinedInput-root': {
          '& fieldset': {
            border: '1px solid rgba(0, 0, 0, 0.5)',
            borderRadius: '8px'
          },
          '&:hover fieldset': {
            border: '1px solid rgba(0, 0, 0, 0.5)'
          },
          '&.Mui-focused fieldset': {
            border: '1px solid rgba(0, 0, 0, 0.5)'
          }
        },
        '&::-webkit-scrollbar': {
          width: '2px'
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#888',
          borderRadius: '6px'
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#555'
        }
      }}>
      <Autocomplete
        value={selectedValue}
        size='small'
        onChange={(event, newValue) => {
          setSelectedValue(newValue) // Update the selected value in state
        }}
        onInputChange={(event, newInputValue) =>
          setSearchProduct(newInputValue)
        }
        ref={autocompleteNext}


        options={flattenedOptions}
        groupBy={option => option.group}
        getOptionLabel={(option) => option.formatedLabel || ""} // Show formatted label
        filterOptions={(options, { inputValue }) => {
          const lowerInputValue = inputValue.toLowerCase()
          // Filter options based on cityName, countryName, airportName, or airportCode
          return options.filter(
            option =>
              (option.municipality &&
                option.municipality.toLowerCase().includes(lowerInputValue)) ||
              (option.full_name &&
                option.full_name.toLowerCase().includes(lowerInputValue)) ||
              (option.name &&
                option.name.toLowerCase().includes(lowerInputValue)) ||
              (option.iata_code &&
                option.iata_code.toLowerCase().includes(lowerInputValue))
          )
        }}
        renderInput={params => (
          <TextField
            {...params}
            label={label}
            placeholder={placeholder}
            // style= {{ borderColor: 'red' }}
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <InputAdornment position='start'>
                  <FlightLandIcon />
                </InputAdornment>
              ),
              style: error ? { borderColor: 'red' } : {},
              onPaste: handlePaste
            }}
            error={error}
            helperText={helperText}
          />
        )}
        renderOption={(props, option) => (
          <ListItem
            sx={{
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: { xs: "flex-start !important", md: "center !important" }
            }}
            {...props}
            secondaryAction={
              <Typography
                sx={{
                  display: { xs: 'none', md: 'block' }
                }}
              >
                {option.iata_code}
              </Typography>
            }
          >
            <Box
              style={{
                minWidth: '35px',
                textAlign: 'left'
              }}
              sx={{
                display: { xs: 'none', md: 'block' }
              }}
            >
              <Image
                height='100'
                width='100'
                style={{
                  width: '20px',
                  height: '20px'
                }}
                alt={option?.name}
                src={option?.img}
              />
            </Box>

            <ListItemText
              sx={{
                fontSize: '12px'
              }}

              primary={`${option?.municipality},${option?.full_name}`}
              secondary={option?.name}
            />
            <ListItemText
              sx={{
                fontSize: '10px',
                display: { xs: 'block', md: 'none' }
              }}

              primary={option.iata_code}
            />
          </ListItem>
        )}

        noOptionsText={
          loading ? <Skeleton variant="text" sx={{ fontSize: '1rem' }} /> :
            <div style={{
              padding: "16px",
              textAlign: "center",
              color: "#666",
              fontSize: "14px",
              backgroundColor: "#f8f9fa",
              borderRadius: "8px"
            }}>
              <strong style={{ fontSize: "16px", color: "#333" }}>
                No results found
              </strong>
              <p style={{ marginTop: "5px" }}>
                Please check the airport or city you have entered or select one from the list.
              </p>
            </div>
        }
      />
    </Box>
  )
}

export default HotelDestination
